import React from 'react';
import { TableRow, TableCell, Box, CircularProgress } from '@mui/material';

interface TableLoadingProps {
  colSpan: number;
}

const TableLoading: React.FC<TableLoadingProps> = ({ colSpan }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="audit-table__cell--loading">
        <Box className="d-flex justify-center items-center gap-2">
          <CircularProgress size={24} />
          <span>Loading audit data...</span>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TableLoading; 